import { Icon, Spinner } from '@acpaas-ui/react-components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import AdminBranchDetails from '../../../../../components/admin/AdminBranchDetails';
import ManuallyAddedLegend from '../../../../../components/admin/ManuallyAddedLegend';
import Accordion from '../../../../../components/core/accordion/Accordion';
import AccordionTab from '../../../../../components/core/accordion/AccordionTab';
import AccordionTabContent from '../../../../../components/core/accordion/AccordionTabContent';
import AccordionTabHeader from '../../../../../components/core/accordion/AccordionTabHeader';
import { useLevelLoadError } from '../../../../../hooks/admin/useLevelLoadError.hook';
import { useLevelUnmount } from '../../../../../hooks/admin/useLevelUnmount.hook';
import { useSetBreadcrumbs } from '../../../../../hooks/admin/useSetBreadcrumbs.hook';
import { ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE } from '../../../../../resources/admin/admin.school.agodi.branches.resource';
import { fetchingSelector } from '../../../../../selectors/fetch.selectors';
import { tableDataSelector } from '../../../../../selectors/resources.selectors';
import adminSchoolsService from '../../../../../services/api/admin.schools.service';
import { schools } from '../../../../../services/bff.api';
import ResourceTable from '../../../../core/ResourceTable';

const AdminSchoolAgodiBranches = () => {
  const params = useParams();
  const [isBranchDetailOpen, setIsBranchDetailOpen] = useState(false);
  const [branchData, setBranchData] = useState({});
  const [isFetchingBranchData, setIsFetchingBranchData] = useState(false);
  const [fetchingBranchError, setFetchingBranchError] = useState('');
  const resource = {
    ...ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE,
    table: {
      ...ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.table,
      dataTransform: (data) =>
        data?.map((i) => ({
          ...i,
          name: i?.spoEntityData?.shadow?.name || i?.spoEntityData?.agodi?.name,
          district: i?.spoEntityData?.shadow?.district || i?.spoEntityData?.agodi?.district,
          postcode: i?.spoEntityData?.shadow?.postcode || i?.spoEntityData?.agodi?.postcode,
          street: i?.spoEntityData?.shadow?.street || i?.spoEntityData?.agodi?.street,
          houseNumber: i?.spoEntityData?.shadow?.houseNumber || i?.spoEntityData?.agodi?.houseNumber,
          phone: i?.spoEntityData?.shadow?.phone || i?.spoEntityData?.agodi?.phone,
          email: i?.spoEntityData?.shadow?.mail || i?.spoEntityData?.agodi?.mail,
          netId: params.netId,
          managementId: params.managementId,
          communityId: params.communityId,
          schoolId: params.schoolId,
          branchId: params.branchId
        }))
    },
    api: {
      get: (urlConfig) =>
        schools.getAgodiBranches(
          params.netId,
          params.managementId,
          params.communityId,
          params.schoolId,
          params.branchId,
          urlConfig
        )
    }
  };
  const agodiBranches = useSelector((state) =>
    tableDataSelector(state, { resource: ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE })
  );
  const fetchingAgodiBranches = useSelector((state) =>
    fetchingSelector(state, { resource: ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE })
  );

  useSetBreadcrumbs(ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key);
  useLevelLoadError(ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key);
  useLevelUnmount(ADMIN_SCHOOL_AGODI_BRANCHES_RESOURCE.key);

  useEffect(() => {
    const fetchSchoolData = () => {
      setIsFetchingBranchData(true);
      adminSchoolsService.getBranch(
        params.netId,
        params.managementId,
        params.communityId,
        params.schoolId,
        params.branchId,
        {
          onError: (message) => {
            setFetchingBranchError(message);
            setIsFetchingBranchData(false);
          },
          onSuccess: (resp) => {
            setBranchData(resp);
            setIsFetchingBranchData(false);
          }
        }
      );
    };

    fetchSchoolData();
  }, [params]);

  return (
    <div className="spo-o-admin-school-management">
      {branchData?.spoEntityMeta?.isManual && <ManuallyAddedLegend className="u-margin-bottom-md" />}
      <div className="u-margin-bottom-md">
        <Accordion>
          <AccordionTab
            headerClass="spo-o-admin-school-management__branch-details"
            open={isBranchDetailOpen}
            onClick={() => setIsBranchDetailOpen(!isBranchDetailOpen)}
          >
            <AccordionTabHeader
              className={`spo-o-admin-school-management__branch-details ${
                branchData?.spoEntityMeta?.isManual ? 'spo-o-admin-school-management__branch-details--highlight' : ''
              }`}
            >
              <span className={fetchingBranchError ? 'u-text-danger' : ''}>
                {fetchingBranchError && <Icon name="ai-alert-triangle" className="u-margin-right-xs" />}
                {isFetchingBranchData
                  ? 'Vestiging ophalen...'
                  : fetchingBranchError ||
                    branchData?.spoEntityData?.shadow?.name ||
                    branchData?.spoEntityData?.agodi?.name}
              </span>
            </AccordionTabHeader>
            <AccordionTabContent>
              {isFetchingBranchData ? (
                <div className="u-text-center">
                  <Spinner />
                </div>
              ) : !fetchingBranchError ? (
                <AdminBranchDetails
                  branch={branchData}
                  params={params}
                  canDelete={!fetchingAgodiBranches && agodiBranches.data.length === 0}
                />
              ) : null}
            </AccordionTabContent>
          </AccordionTab>
        </Accordion>
      </div>
      <ResourceTable resource={resource} />
    </div>
  );
};

export default AdminSchoolAgodiBranches;
